import type { FocusArea } from './types';

/** V1 focus areas — user picks; product never diagnoses. */
export const FOCUS_AREAS: FocusArea[] = [
  {
    id: 'connect',
    label: 'Connect',
    blurb: 'Approaching people, keeping plans, offline presence.',
    safetyClass: 'standard',
  },
  {
    id: 'sex',
    label: 'Sex',
    blurb: 'Patterns around sex that feel like they run the show.',
    safetyClass: 'standard',
  },
  {
    id: 'chems',
    label: 'Chems',
    blurb: 'Meth, chemsex, or substance patterns — your pace, your goal.',
    safetyClass: 'substance',
  },
  {
    id: 'apps',
    label: 'Apps',
    blurb: 'Compulsive hookup-app checking, scrolling, disappearing.',
    safetyClass: 'standard',
  },
  {
    id: 'body',
    label: 'Body',
    blurb: 'Sleep, training, food, weekends that fell apart.',
    safetyClass: 'standard',
  },
  {
    id: 'confidence',
    label: 'Head',
    blurb: 'Confidence, validation loops, the noise in your head.',
    safetyClass: 'standard',
  },
  {
    id: 'life',
    label: 'Life',
    blurb: 'General stuckness, momentum, getting your days back.',
    safetyClass: 'standard',
  },
];

export const focusAreaById = (id: string): FocusArea | undefined =>
  FOCUS_AREAS.find((a) => a.id === id);
